import { CleanSchema, get } from '../../json-transform';

export const linker = new CleanSchema({
  action: get('action').asString(),
  stream_ids: get('stream_ids').asArrayOf(String),
  group_id: get('group_id').asString(),
});
